const initColumnBackgroundColor = () => {
  const moduleContainer = document.querySelector('.sixty-forty');

  if (moduleContainer) {
    let groupOne = document.querySelector(
      '.sixty-forty__groups.cell-1',
    ).offsetHeight;
    let groupTwo = document.querySelector(
      '.sixty-forty__groups.cell-2',
    ).offsetHeight;

    const whiteBackground = document.createElement('div');
    whiteBackground.className = 'white-background';

    const greyBackground = document.createElement('div');
    greyBackground.className = 'grey-background';

    moduleContainer.appendChild(whiteBackground);
    moduleContainer.appendChild(greyBackground);

    const whiteBackgroundContainer =
      document.querySelector('.white-background');
    const greyBackgroundContainer = document.querySelector('.grey-background');

    setHeight(groupOne, groupTwo);

    window.addEventListener('resize', () => {
      groupOne = document.querySelector(
        '.sixty-forty__groups.cell-1',
      ).offsetHeight;
      groupTwo = document.querySelector(
        '.sixty-forty__groups.cell-2',
      ).offsetHeight;

      setHeight(groupOne, groupTwo);
    });
  }

  function setHeight(containerOne, containerTwo) {
    const whiteBackgroundContainer =
      document.querySelector('.white-background');
    const greyBackgroundContainer = document.querySelector('.grey-background');

    if (window.innerWidth < 960) {
      whiteBackgroundContainer.style.height =
        parseInt(containerOne) + 200 + 'px';
      greyBackgroundContainer.style.height = parseInt(containerTwo) + 30 + 'px';
    } else {
      whiteBackgroundContainer.style.height =
        parseInt(containerOne) + 60 + 'px';
      greyBackgroundContainer.style.height = parseInt(containerTwo) + 20 + 'px';
    }
  }
};

export default initColumnBackgroundColor;
